export default __webpack_public_path__ + "static/media/party.8db541d6.svg";